<div class="d-flex align-items-center">
    <input #searchFieldInput
           (ngModelChange)="inputValueChanged($event)"
           [attr.data-qa]="'search-input-' + inputIndex"
           [ngClass]="inputClass"
           [ngModel]="value"
           [wsMask]="inputMask"
           class="form-control"
           tabindex="0"
           type="text">
    @if (idpResults?.length && currentDocument?.idpStatusID) {
        <div class="btn-group ms-2"
             dropdown
             container="body"
             [(isOpen)]="showIdpMenu">
            <button type="button"
                    class="ace-btn has-icon btn-primary m-0"
                    tabindex="0"
                    [attr.data-qa]="'idp-menu-button-' + inputIndex"
                    [disabled]="!currentDocument?.taxBillOcrResults && !currentDocument.assessmentNoticeOcrResults"
                    dropdownToggle
                    (mouseenter)="showIdpMenu = true; idpButtonHovered = true"
                    (mouseleave)="buttonHoverOut()"
                    (focusin)="menuFocusIn()"
                    (focusout)="menuFocusOut()"
                    (keydown)="keyedSelection($event)"
                    (click)="setSingleIdpValue()">
                <small>IDP</small>
            </button>
            <ul *dropdownMenu #testEl class="dropdown-menu" role="menu"
                (mouseenter)="showIdpMenu = true; idpMenuHovered = true;"
                (mouseleave)="menuHoverOut()">
                @for (field of idpResults | sortBy: 'asc'; track field; let i = $index) {
                    <li role="menuitem">
                        <div class="dropdown-item clickable d-flex flex-column"
                             [id]="'idpValue-' + i"
                             [attr.data-qa]="'idp-menu-item-' + i"
                             [ngClass]="{ 'active': field === value }"
                             (click)="menuItemSelected(field)">
                            <!-- <span *ngIf="field.subCategory">{{field.subCategory}}</span> -->
                            <a>{{ field }}</a>
                        </div>
                    </li>
                }
            </ul>
        </div>
    }
</div>

